module.exports = "/assets/images/4fa0fa1e53b894a50b2ed8fa45f26def.jpg";